<template>
  <div class="carrot">
    <form name="frm" method="post" action="mail_recommend.html">
      <table width="844" border="0" cellspacing="0" cellpadding="0" align="center">
        <tbody>
        <tr>
          <td><img src="http://www.carrotenglish.com/mail/img/juice_top.jpg" width="844"
                   height="70"></td>
        </tr>
        <tr>
          <td style="padding-top:70px;padding-bottom:25px; padding-left:80px;"><font
            style="font-family:'Malgun Gothic'; font-size:22px; color:#333333; letter-spacing:-1px;line-height:38px;"><span
            style="font-weight:bold; font-size:25px;">실시간으로 세계를 꿰뚫는 눈, 생생 로이터 동영상 뉴스</span><br>매일
            출퇴근길에 로이터 뉴스와 함께 유익한 학습하세요!</font></td>
        </tr>
        <tr>
          <td style="padding-bottom:25px; padding-left:80px;"><font
            style="font-family:'Malgun Gothic'; font-size:16px; color:#333333; letter-spacing:-1px;line-height:30px;">생생
            로이터 동영상 뉴스는 당근영어가 무료로 제공하는 <b>지식 공유 서비스</b>입니다.<br>소중한 친구 혹은 직장동료에게 생생 로이터 동영상 뉴스를 맘껏
            추천해 주세요.</font></td>
        </tr>

        <tr>
          <td style="padding-top:15px;padding-bottom:15px; padding-left:80px;"><font
            style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">추천
            하시는 분</font>
            <input v-model="input.rName" style="padding:5px; border:1px solid #cacaca; width:150px;"
                   type="text" name="from_name" value="">
            <input v-model="input.rEmail" type="hidden" name="r_email">
          </td>
        </tr>

        <tr>
          <td style="padding-top:0px;padding-bottom:45px; padding-left:80px;">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">추천
              받으시는 분</font>
            <select v-model="input.cnt"
                    style="font-family:'Malgun Gothic'; font-size:14px; color:#333333; height:25px;"
                    name="recommend_su" @change="changeInputDom" id="recommend_su">
              <option value="">선택해주세요.</option>
              <option value="1">1명</option>
              <option value="2">2명</option>
              <option value="3">3명</option>
              <option value="4">4명</option>
              <option value="5">5명</option>
              <option value="6">6명</option>
              <option value="7">7명</option>
              <option value="8">8명</option>
              <option value="9">9명</option>
              <option value="10">10명</option>
            </select>
          </td>
        </tr>

        <tr v-show="input.cnt > 0">
          <td style="padding-top:5px;padding-bottom:20px; padding-left:80px;">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">Name</font>
            <input style="padding:5px; border:1px solid #cacaca; width:150px;" type="text" name="input"
                   v-model="input.name_1" id="name_1">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px; padding-left:20px;">E-mail</font>
            <input style="padding:5px; border:1px solid #cacaca; width:250px;" type="text" name="input"
                   v-model="input.email_1" id="email_1">
          </td>
        </tr>
        <tr v-show="input.cnt > 1">
          <td style="padding-top:5px;padding-bottom:20px; padding-left:80px;">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">Name</font>
            <input style="padding:5px; border:1px solid #cacaca; width:150px;" type="text" name="input"
                   v-model="input.name_2" id="name_2">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px; padding-left:20px;">E-mail</font>
            <input style="padding:5px; border:1px solid #cacaca; width:250px;" type="text" name="input"
                   v-model="input.email_2" id="email_2">
          </td>
        </tr>
        <tr v-show="input.cnt > 2">
          <td style="padding-top:5px;padding-bottom:20px; padding-left:80px;">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">Name</font>
            <input style="padding:5px; border:1px solid #cacaca; width:150px;" type="text" name="input"
                   v-model="input.name_3" id="name_3">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px; padding-left:20px;">E-mail</font>
            <input style="padding:5px; border:1px solid #cacaca; width:250px;" type="text" name="input"
                   v-model="input.email_3" id="email_3">
          </td>
        </tr>
        <tr v-show="input.cnt > 3">
          <td style="padding-top:5px;padding-bottom:20px; padding-left:80px;">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">Name</font>
            <input style="padding:5px; border:1px solid #cacaca; width:150px;" type="text" name="input"
                   v-model="input.name_4" id="name_4">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px; padding-left:20px;">E-mail</font>
            <input style="padding:5px; border:1px solid #cacaca; width:250px;" type="text" name="input"
                   v-model="input.email_4" id="email_4">
          </td>
        </tr>
        <tr v-show="input.cnt > 4">
          <td style="padding-top:5px;padding-bottom:20px; padding-left:80px;">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">Name</font>
            <input style="padding:5px; border:1px solid #cacaca; width:150px;" type="text" name="input"
                   v-model="input.name_5" id="name_5">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px; padding-left:20px;">E-mail</font>
            <input style="padding:5px; border:1px solid #cacaca; width:250px;" type="text" name="input"
                   v-model="input.email_5" id="email_5">
          </td>
        </tr>
        <tr v-show="input.cnt > 5">
          <td style="padding-top:5px;padding-bottom:20px; padding-left:80px;">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">Name</font>
            <input style="padding:5px; border:1px solid #cacaca; width:150px;" type="text" name="input"
                   v-model="input.name_6" id="name_6">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px; padding-left:20px;">E-mail</font>
            <input style="padding:5px; border:1px solid #cacaca; width:250px;" type="text" name="input"
                   v-model="input.email_6" id="email_6">
          </td>
        </tr>
        <tr v-show="input.cnt > 6">
          <td style="padding-top:5px;padding-bottom:20px; padding-left:80px;">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">Name</font>
            <input style="padding:5px; border:1px solid #cacaca; width:150px;" type="text" name="input"
                   v-model="input.name_7" id="name_7">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px; padding-left:20px;">E-mail</font>
            <input style="padding:5px; border:1px solid #cacaca; width:250px;" type="text" name="input"
                   v-model="input.email_7" id="email_7">
          </td>
        </tr>
        <tr v-show="input.cnt > 7">
          <td style="padding-top:5px;padding-bottom:20px; padding-left:80px;">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">Name</font>
            <input style="padding:5px; border:1px solid #cacaca; width:150px;" type="text" name="input"
                   v-model="input.name_8" id="name_8">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px; padding-left:20px;">E-mail</font>
            <input style="padding:5px; border:1px solid #cacaca; width:250px;" type="text" name="input"
                   v-model="input.email_8" id="email_8">
          </td>
        </tr>
        <tr v-show="input.cnt > 8">
          <td style="padding-top:5px;padding-bottom:20px; padding-left:80px;">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">Name</font>
            <input style="padding:5px; border:1px solid #cacaca; width:150px;" type="text" name="input"
                   v-model="input.name_9" id="name_9">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px; padding-left:20px;">E-mail</font>
            <input style="padding:5px; border:1px solid #cacaca; width:250px;" type="text" name="input"
                   v-model="input.email_9" id="email_9">
          </td>
        </tr>
        <tr v-show="input.cnt > 9">
          <td style="padding-top:5px;padding-bottom:20px; padding-left:80px;">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px;">Name</font>
            <input style="padding:5px; border:1px solid #cacaca; width:150px;" type="text" name="input"
                   v-model="input.name_10" id="name_10">
            <font
              style="font-family:'Malgun Gothic'; font-size:15px; color:#333333; letter-spacing:-1px; padding-right:15px; padding-left:20px;">E-mail</font>
            <input style="padding:5px; border:1px solid #cacaca; width:250px;" type="text" name="input"
                   v-model="input.email_10" id="email_10">
          </td>
        </tr>
        <tr>
          <td align="center" style="padding-top:55px;">
            <font @click="doRecommend" style="font-family:'Malgun Gothic; cursor:pointer;'; text-decoration:underline; color:#dc0a0b; font-size:16px;">
              생생 로이터 동영상 뉴스를 추천합니다 &gt;
            </font>
          </td>
        </tr>
        </tbody>
      </table>
    </form>
  </div>
</template>

<script>
import Menu from '../../components/commons/incMenu'
import Paginate from 'vuejs-paginate'

export default {
  name: 'ReuterAdd',
  components: {
    Menu,
    Paginate
  },
  data () {
    return {
      input: {
        rName: '',
        rEmail: '',
        cnt: 1
      }
    }
  },
  mounted () {
    let rName = this.$route.query.r_name
    let rEmail = this.$route.query.r_email

    console.log(rName, rEmail)

    if(rName === undefined || rName === '' || rEmail === undefined || rEmail === ''){
      alert('올바르지 않은 URL 입니다')
      history.back()
    }

    this.selectRecommender()
  },
  methods: {
    selectRecommender: function () {
      this.input.rName = this.$route.query.r_name
      this.input.rEmail = this.$route.query.r_email
    },
    changeInputDom: function () {
      const cnt = this.input.cnt;
      for(let i=10; i>cnt; i--){
        eval('delete this.input.name_' + i)
        eval('delete this.input.email_' + i)
      }
    },
    doRecommend: function () {
      const url = '/v1/api/admin/reuters-recommend'

      this.axios.post(url, this.input)
      .then(res => {
        if (res.data.err === 0) {
          alert('추천 처리가 완료되었습니다.')
          location.reload()
        } else {
          alert(res.data.result)
        }
      })
      .catch(err => {
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          this.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })
    }
  },
}
</script>

<style scoped>
td {
  font-size: 9pt;
  font-family: Dotum, Arial;
  color: #474747;
  line-height: 16px;
  word-break: break-word;
}

.tit04 {
  font-size: 14pt;
  font-family: Dotum;
  color: #454aa0;
  font-weight: bold;
  line-height: 20px;

  word-break: break-word;
}

.tit04_sub {
  font-size: 12px;
  font-family: Dotum;
  color: #454aa0;
  font-weight: bold;
  line-height: 20px;

  word-break: break-word;
}

.tit05 {
  font-size: 16pt;
  font-family: Arial;
  color: #454aa0;
  line-height: 33px;

  word-break: break-word;
}

.tit05_ctestch {
  font-size: 28pt;
  font-family: Arial;
  color: #454aa0;
  line-height: 33px;

  word-break: break-word;
}

.tit03 {
  font-size: 14pt;
  font-family: Arial;
  color: #454aa0;
  line-height: 20px;

  word-break: break-word;
}

.tit06 {
  font-size: 8pt;
  font-family: Arial;
  color: #454aa0;
  line-height: 20px;

  word-break: break-word;
}

.tit08 {
  font-size: 8pt;
  font-family: Dotum;
  color: #8591a9;
  line-height: 17px;

  word-break: break-word;
}

.tit07 {
  font-size: 10.5pt;
  font-family: Arial;
  color: #292929;
  line-height: 27px;
  letter-spacing: 0;
  word-break: break-word;
}

.tit07 .input {
  border: 1px solid #ffffff;
  border-bottom: 1px solid #e0e0e0;
  background: #ffffff;
  padding: 2px 5px;
  height: 23px;
}

.ans07 {
  font-size: 10.5pt;
  font-family: Arial;
  color: #292929;
  line-height: 27px;
  letter-spacing: 0;
  word-break: break-word;
}

.ans07 .radio {
  border: none;
  background: #ffffff;
}


.tit09 {
  font-size: 9pt;
  font-family: Arial;
  color: #006eae;
  line-height: 17px;
  letter-spacing: 0;
  word-break: break-word;
}

.tit10 {
  font-size: 9pt;
  font-family: Arial;
  color: #FFFFFF;
  line-height: 17px;
  letter-spacing: 0;
  word-break: break-word;
}

.tit11 {
  font-size: 19pt;
  font-family: Arial;
  color: #454aa0;
  line-height: 20px;
  word-break: keep-all;
}

/*==Title==*/

/* menu link */

a:link {
  text-decoration: none;
  color: #474747;
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
}

a:visited {
  text-decoration: none;
  color: #474747;
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
}

a:active {
  text-decoration: none;
  color: #0000ff;
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
}

a:hover {
  text-decoration: none;
  color: #0000ff;
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
}

a.menu:link {
  color: #444444;
  text-decoration: none;
}

a.menu:visited {
  color: #444444;
  text-decoration: none;
}

a.menu:hover {
  color: #ff7e00;
  text-decoration: none;
}

a.menu02:link {
  color: #3b5998;
  text-decoration: none;
}

a.menu02:visited {
  color: #3b5998;
  text-decoration: none;
}

a.menu02:hover {
  color: #0052ff;
  text-decoration: none;
}

a.menu03:link {
  color: #006eae;
  text-decoration: none;
}

a.menu03:visited {
  color: #006eae;
  text-decoration: none;
}

a.menu03:hover {
  color: #0000ff;
  text-decoration: none;
}

a.menu04:link {
  color: #ffffff;
  text-decoration: none;
}

a.menu04:visited {
  color: #ffffff;
  text-decoration: none;
}

a.menu04:hover {
  color: #ffffff;
  text-decoration: none;
}

a.menu05:link {
  color: #000000;
  text-decoration: none;
}

a.menu05:visited {
  color: #000000;
  text-decoration: none;
}

a.menu05:hover {
  color: #0000ff;
  text-decoration: none;
}

a.menu06:link {
  color: #3b5998;
  text-decoration: none;
}

a.menu06:visited {
  color: #3b5998;
  text-decoration: none;
}


a.menu06:hover {
  color: #0600ff;
  text-decoration: none;
}

a.menu01:link {
  color: #2c2c2c;
  text-decoration: none;
}

a.menu01:visited {
  color: #2c2c2c;
  text-decoration: none;
}

a.menu01:hover {
  color: #0089f3;
  text-decoration: none;
}

/* TABLE ?? ???? */
.ln {
}

.t00 {
  background-color: #6e8ddb;
}

.t01 {
  background-color: #dde4f4;
  border: 1px solid #CFD2D3;
  color: #676767;
  font-weight: bold;
  text-align: left;
  padding-left: 15px;
  padding-top: 1px;
}

.t02 {
  background-color: #dfdfdf;
  border: 1px solid #CFD2D3;
  color: #676767;
  font-weight: bold;
  text-align: center;
}

.t01-1 {
  background-color: #ffffff;
  border: 1px solid #CFD2D3;
  color: #474747;
  font-weight: normal;
  text-align: left;
  padding-left: 15px;
  padding-top: 1px;
  padding-right: 15px;
}

.t01-2 {
  background-color: #ffffff;
  border: 1px solid #CFD2D3;
  color: #474747;
  font-weight: normal;
  text-align: left;
  padding-left: 5px;
  padding-top: 1px;
  padding-right: 5px;
}

img {
  border: 0
}

.table02 {
  font-size: 9pt;
  font-family: Verdana;
  color: #454aa0;
  font-weight: bold;
  line-height: 17px;
  word-break: break-word;
}

input.button {
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
  background-color: #D4D0C8;

  height: 19px;
}

input.a {
  border: 0px;
  background-color: #E7EFD6;
  text-align: left;
  height: 20px;
  padding-left: 3px;
  padding-top: 5px;
  color: #676767;
}

input.a01 {
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
  background-color: #ffffff;

  height: 19px;
}

input.button {
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
  background-color: #D4D0C8;

  height: 19px;
}

input.radio {
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
  background-color: #99CA3C;
  border: 0 solid #C2C2C2;
}

input.show {
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
  background-color: #F0F0F0;
  height: 19px;
}

select {
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
  background-color: #eeeeee;

  height: 19px;
}

textarea {
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
  background-color: #ffffff;

}

textarea.border {
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
  background-color: #ffffff;

  height: 19px;
}

textarea.border2 {
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
  background-color: #ffffff;

  height: 40px;
  width: 400px;
}

textarea.border3 {
  font-size: 9pt;
  font-family: Dotum, DotumChe, Verdana;
  background-color: #ffffff;

  height: 100px;
  width: 400px;
}

BODY {
  scrollbar-3dlight-color: #FFFFFF;
  scrollbar-arrow-color: #939393;
  scrollbar-track-color: #F4F4F4;
  scrollbar-darkshadow-color: #FFFFFF;
  scrollbar-face-color: #EDEDED;
  scrollbar-highlight-color: #FAFAFA;
  scrollbar-shadow-color: #BDBDBD;
}


.padding_l5 {
  padding-left: 5px;
  background-color: #ffffff;
}

.padding_l10 {
  padding-left: 10px;
  background-color: #ffffff;
}

.padding_l20 {
  padding-left: 20px;
  background-color: #ffffff;
}

.padding_r5 {
  padding-left: 5px;
  background-color: #ffffff;
}

.padding_r10 {
  padding-left: 10px;
  background-color: #ffffff;
}

.padding_r20 {
  padding-left: 20px;
  background-color: #ffffff;
}

.padding_all2 {
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 2px;
  padding-right: 2px;
}

.padding_all5 {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
}

.padding_all10 {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}

.padding_all20 {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.padding_l5_bg {
  padding-left: 5px;
  background-color: #EAF5FF;
}

.padding_l10_bg {
  padding-left: 10px;
  background-color: #EAF5FF;
}

.padding_l15_bg {
  padding-left: 10px;
  background-color: #F9F9F9;
}

.padding_l20_bg {
  padding-left: 20px;
  background-color: #EAF5FF;
}

.padding_r5_bg {
  padding-left: 5px;
  background-color: #F6F6F6;
}

.padding_r10_bg {
  padding-left: 10px;
  background-color: #F6F6F6;
}

.padding_r20_bg {
  padding-left: 20px;
  background-color: #F6F6F6;
}

.padding_all2_bg {
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 2px;
  padding-right: 2px;
  background-color: #EAF5FF;
}

.padding_all5_bg {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  padding-right: 5px;
  background-color: #EAF5FF;
}

.padding_all10_bg {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #EAF5FF;
}

.padding_all20_bg {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #EAF5FF;
}

.padding_c {
  text-align: center;
}

.padding_c_bg {
  text-align: center;
  background-color: #EAF5FF;
  font-weight: bold;
}

.padding_c_bg1 {
  text-align: center;
  background-color: #EAF5FF;
}

div.kv {
  width: 350px;
  height: 355px;
  overflow: scroll /* hidden|auto|scroll */;
  -webkit-overflow-scrolling: touch;
}

div.ex {
  width: 350px;
  height: 355px;
  overflow: scroll /* hidden|auto|scroll */;
  -webkit-overflow-scrolling: touch;
}

#wrapper {
  position: relative;
  z-index: 1;
  width: 350px /* your desired width, auto and 100% are fine */;
  height: 364px /* element height */;
  overflow-y: scroll /* hidden|auto|scroll */;
  -webkit-overflow-scrolling: touch;
  text-overflow-mode: ellipsis;
}


.cafe_table {
  position: relative;
  width: 970px;
  height: 750px;
}

.cu_banner {
  position: absolute;
  top: 573px;
  right: 163px;
  margin: 0;
  padding: 0;
}

.cu_pop {
  position: absolute;
  top: 520px;
  left: 335px;
  width: 360px;
  z-index: 50;
  border: 1px solid #d4d4d4;
}

.cu_tit {
  background: #504e4e;
  height: 26px;
  margin: 0;
  padding: 8px 10px 0 20px;
}

.cu_tit_img {
  float: left;
}

.cu_close_img {
  float: right;
}

.cu_cont {
  background: #ffffff;
  padding-top: 13px;
  margin: 0;
  height: 160px;
  overflow-y: auto;
  padding-left: 0;
}

.notice {
  font-size: 11px;
  color: #ff7e00;
  padding-left: 20px;
  padding-bottom: 13px;
}

.title_choice {
  font-weight: bold;
  font-size: 12px;
  color: #5f5f5f;
  padding-left: 20px;
  height: 23px;
}

.title_choice span {
  font-family: arial;
  color: #5f5f5f;
}

.title_cafe {
  font-weight: bold;
  font-size: 12px;
  color: #5f5f5f;
  padding-left: 20px;
  padding-bottom: 3px;
  padding-top: 10px;
  clear: both;
}

.list {
  background: url(http://new.carrotenglish.com/cafe/img/cu_bull.jpg) no-repeat;
  background-position: 22px 6px;
  margin: 0;
  width: 285px;
  line-height: 14px;
  padding: 0 15px 0px 30px;
  float: left;
  margin-bottom: 7px;
}

.list a {
  font-size: 11px;
  color: #7f7f7f;
}

.list a:hover {
  color: #ff7e00;
  text-decoration: underline;
  font-size: 11px;
}

li {
  list-style-type: none;
  list-style-image: none;
}

a span {
  background: url(http://new.carrotenglish.com/images/common/btn_bull.jpg) no-repeat right;
  padding-right: 9px;
  margin-right: 13px;
  text-decoration: underline;
  font-size: 11px;
  color: #656565;
}

a:hover span {
  background: url(http://new.carrotenglish.com/images/common/btn_bull.jpg) no-repeat right;
  padding-right: 9px;
  margin-right: 13px;
  text-decoration: underline;
  font-size: 11px;
  color: #282828;
}

a .btn_leuter_11_wh {
  font-size: 11px;
  color: #dedede;
  background: none;
  text-decoration: underline;
}

a:hover .btn_leuter_11_wh {
  font-size: 11px;
  color: #ffffff;
  background: none;
  text-decoration: underline;
}

a .btn_leuter_11_wh_nomargin {
  font-size: 11px;
  color: #dedede;
  background: none;
  text-decoration: underline;
  margin-right: 0;
}

a:hover .btn_leuter_11_wh_nomargin {
  font-size: 11px;
  color: #ffffff;
  background: none;
  text-decoration: underline;
  margin-right: 0;
}

.font_comt_11 {
  font-size: 11px;
  color: #717171;
}

a .btn_next_class {
  font-size: 11px;
  color: #282828;
  background: url(http://new.carrotenglish.com/cafe/img/btn_nxt_bull.png) no-repeat right;
}

a:hover .btn_next_class {
  font-size: 11px;
  color: #000000;
  background: url(http://new.carrotenglish.com/cafe/img/btn_nxt_bull.png) no-repeat right;
}


a .btn_pre_class {
  font-size: 11px;
  color: #282828;
  background: url(http://new.carrotenglish.com/cafe/img/btn_pre_bull.png) no-repeat left;
  padding-left: 12px;
}

a:hover .btn_pre_class {
  font-size: 11px;
  color: #000000;
  background: url(http://new.carrotenglish.com/cafe/img/btn_pre_bull.png) no-repeat left;
  padding-left: 12px;
}


a .btn_answer_class {
  text-decoration: none;
  color: #ff232b;
  background: url(http://new.carrotenglish.com/cafe/img/btn_answer_bull.png) no-repeat right;
  margin: 0;
}

a:hover .btn_answer_class {
  text-decoration: none;
  color: #ff232b;
  background: url(http://new.carrotenglish.com/cafe/img/btn_answer_bull.png) no-repeat right;
  margin: 0;
}

a .tit03 {
  font-size: 14pt;
  font-family: Arial;
  color: #454aa0;
  line-height: 20px;

  word-break: break-word;
  background: none;
}

a:hover .tit03 {
  font-size: 14pt;
  font-family: Arial;
  color: #454aa0;
  line-height: 20px;

  word-break: break-word;
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/reuters/mailRecommend.vue